import { useEffect } from 'react';
import { router } from '@inertiajs/react';

async function loadPreline() {
    return import('preline/dist/index.js');
}

export default function PrelineScript() {
    useEffect(() => {
        const initPreline = async () => {
            await loadPreline();
            window.HSStaticMethods?.autoInit();
        };

        // Run on first load
        initPreline();

        // Re-run after every Inertia navigation
        const unlisten = router.on('navigate', () => {
            initPreline();
        });

        // Cleanup
        return () => {
            unlisten();
        };
    }, []);

    return null;
}
